import { ExternalLinkIcon } from "@chakra-ui/icons";
import { Link, LinkProps } from "@chakra-ui/react";
import { formatUrlAsDomain } from "utils/formatting";

type Props = LinkProps & {
  hasIcon?: boolean;
};

export default function ExternalDomainLink({
  children,
  hasIcon = false,
  ...rest
}: Props) {
  const { href } = rest;
  return (
    <Link isExternal onClick={(e) => e.stopPropagation()} {...rest}>
      {formatUrlAsDomain(href)}
      {hasIcon && <ExternalLinkIcon mt="-.25em" ml={1} fontSize=".8em" />}
      {children}
    </Link>
  );
}
